type PublishProps = {
  gameStatus: string
  handlePublish: () => void
  publishStatus: boolean
}

const PublishButton: React.FC<PublishProps> = ({
  gameStatus,
  handlePublish,
  publishStatus,
}) => {
  return (
    <>
      {publishStatus && gameStatus === 'published' ? (
        <button
          onClick={handlePublish}
          className="primary-button min-h-[42px] px-2 lg:min-w-32"
        >
          Reshare
        </button>
      ) : publishStatus && gameStatus === 'save_draft' ? (
        <button
          onClick={handlePublish}
          className="primary-button min-h-[42px] px-2 lg:min-w-32"
        >
          Reshare
        </button>
      ) : (
        <button
          onClick={handlePublish}
          className="primary-button min-h-[42px] px-2 lg:min-w-32"
        >
          Share
        </button>
      )}
    </>
  )
}

export default PublishButton
